import { BaseComponent } from '@pixelart/component-handler';

export class Contentlist extends BaseComponent {
    protected ITEM_SELECTOR: string = '.listitem';
    protected LIST_CONTAINER_SELECTOR: string = '.contentlist__content-container';
    protected BEFORE_SHUFFLE_CLASS: string = 'contentlist--before-shuffle';

    public constructor(element: Element) {
        super(element);
    }

    public init() {
        if (parseInt(this.$element.data('shuffle'), 10) === 1) {
            this.shuffleItems();
        }
    }

    public shuffleItems() {
        const $container = this.$element.find(this.LIST_CONTAINER_SELECTOR);
        const $items = $container.find(this.ITEM_SELECTOR);

        let j;
        for (let i = 0; i < $items.length; i++) {
            j = Math.floor(Math.random() * $items.length);
            $($items.get(i)).before($($items.get(j)));
        }

        this.$element.removeClass(this.BEFORE_SHUFFLE_CLASS);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/contentlist/contentlist.class.ts